module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "bottom-box resizable",
    style: ({
      height: height + 'px'
    }),
    on: {
      "click": function($event) {
        $emit('click')
      }
    }
  }, [_h('resizer', {
    attrs: {
      "type": "horizontal"
    },
    on: {
      "resizer:begin": onResizeBegin,
      "resizer:resize": onResize
    }
  }), " ", _h('div', {
    staticClass: "box-header"
  }, [_m(0), " ", _h('span', {
    staticClass: "box-caret glyphicon glyphicon-menu-down",
    on: {
      "click": function($event) {
        $emit('console:close')
      }
    }
  })]), " ", _h('div', {
    staticClass: "console-container"
  }, [_m(1), " ", _h('textarea', {
    ref: "textarea",
    attrs: {
      "id": "console"
    }
  })])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "box-title"
  }, ["Output"])
}},function (){with(this) {
  return _h('div', {
    staticClass: "console-seal"
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-65b83951!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Console.vue
 ** module id = 132
 ** module chunks = 2
 **/